import React, {useRef} from "react";
import { useLanguage } from "../../context/LanguageContext";
import "./portfolio.css";
import {motion, useScroll, useTransform} from "framer-motion";
import nemesio from '../../assets/portfolio-background/nemesio.png'
import bancoCentral from '../../assets/portfolio-background/banco-central.png'
import swappi from '../../assets/portfolio-background/swappi.png'
import swappiGif from '../../assets/portfolio-background/swappi.gif'
import transbank from '../../assets/portfolio-background/aws-diagram.png'
import fabricantes from '../../assets/portfolio-background/fabricantes.png'

interface PortfolioProps {
    item: {
        id: string | number,
        img: string,
        item?: string,
        desc: string,
        descKey?: string,
        title: string,
        gif?: string,
        tags?: string[],
        link?: string
    }
}


const items = [
    {
        id: 0,
        title: "Fabricantes La Salada",
        img: fabricantes,
        desc: "End-to-end B2B/B2C marketplace connecting clothing manufacturers in Argentina with buyers across LatAm. Built the full ecosystem: React web platform, React Native mobile app, Java/Spring Boot backend, Meilisearch for sub-50ms product search, and cross-border payment rails (ARS→USDC→CLP) via dLocal, Belo & TransFi.",
        descKey: "portfolio.fabricantes.desc",
        tags: ["React", "Spring Boot", "React Native", "Meilisearch", "dLocal", "Docker"],
        link: "https://www.fabricanteslasalada.com"
    },
    {
        id: 1,
        title: "Nemesio",
        img: nemesio,
        desc: "Platform used by the company \"Bendito Residuo\" for waste management by associated companies.",
        descKey: "portfolio.nemesio.desc",
        tags: ["Svelte", "Django", "Python", "Jenkins", "PostgreSQL"]
    },
    {
        id: 2,
        title: "Swappi",
        img: swappi,
        desc: "Application for condominium management, including common expenses, maintenance, and task delegation.",
        gif: swappiGif,
        descKey: "portfolio.swappi.desc",
        tags: ["React Native", "iOS", "Android", "Mobile Development"]
    },
    {
        id: 3,
        title: "SGD Banco Central",
        img: bancoCentral,
        desc: "Debt Management System application for the Central Bank of Chile.",
        descKey: "portfolio.sgd.desc",
        tags: ["Java", "Spring Boot", "React", "JBoss", "SQL Server"]
    },
    {
        id: 4,
        title: "Transbank",
        img: transbank,
        desc: "DevOps engineering role at Chile's largest payment processor.",
        descKey: "portfolio.transbank.desc",
        tags: ["AWS", "Terraform", "IaC", "CI/CD", "Jenkins"]
    }
];

const Single: React.FC<PortfolioProps> = ({item}) => {
    const ref = useRef<HTMLDivElement>(null);
    const { t } = useLanguage();

    const {scrollYProgress} = useScroll({
        target: ref,
    });

    const y = useTransform(scrollYProgress, [0, 1], [-50, 50]);

    return (
        <section className={'project' + item.id}>
            <div className="container">
                <div className="wrapper">
                    <div className="imageContainer" ref={ref}>
                        <img src={item.img} alt="" className="img-fluid w-100 h-auto rounded image"/>
                        {item.gif && <img src={item.gif} alt="" className="img-fluid w-100 h-auto rounded gif"/>}
                    </div>
                    <div className="textContainer">
                        {item.id === 0 && (
                            <div className="portfolio-flagship-badge">★ Flagship Case Study</div>
                        )}
                        <h2>{item.title}</h2>
                        <p>{item.descKey ? t(item.descKey) : item.desc}</p>
                        {item.tags && (
                            <div className="portfolio-tags">
                                {item.tags.map((tag: string) => (
                                    <span key={tag} className="portfolio-tag">{tag}</span>
                                ))}
                            </div>
                        )}
                        {item.link ? (
                            <a href={item.link} target="_blank" rel="noopener noreferrer" className="portfolio-link-button">
                                {t('portfolio.visit')} <i className='bx bx-link-external'></i>
                            </a>
                        ) : (
                            <a href="#Contact" className="portfolio-link-button">
                                {t('portfolio.contact')} <i className='bx bx-message-square-detail'></i>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

const Portfolio = () => {
    const { t } = useLanguage();
    /*    const ref = useRef();

        const {scrollYProgress} = useScroll({
            target: ref,
            offset: ["end end", "start start"],
        });

        const scaleX = useSpring(scrollYProgress, {
            stiffness: 100,
            damping: 30,
        });*/

    return (
        <div className="portfolio">
            <div className="portfolio-title">
                <motion.h2 initial={{opacity: 0}}
                           whileInView={{opacity: 1}}
                           exit={{opacity: 0}}
                           transition={{duration: 3}}
                >
                    {t('portfolio.title')}
                </motion.h2>
            </div>
            {items.map((item) => (
                <Single item={item} key={item.id}/>
            ))}
        </div>
    );
};

export default Portfolio;